module.exports = __webpack_public_path__ + "img/spring_trip-20160416-11-1024x576.728f4378.jpg";